import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const getApplicationStatusFileList = async () => {
  try {
    const apiLink = `${endpoint}/api/get-application-status-files-list`;
    const response = await axios.get(apiLink);
    return response.data;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default getApplicationStatusFileList;